export default __webpack_public_path__ + "static/worker-related-f281645790dae99a2edf8b04c2592ff8.jpg";